import React from 'react';
import { TextInput, SelectInput } from 'react-admin';
import '../styles.css';

import { trustedContactRelationship } from '../../../helpers/mappings';
import { phoneFormatter, phoneParser } from '../../../helpers/utils';

export default props => (
  <table style={{ width: '100%' }}>
    <tbody>
      <tr>
        <td style={{ width: '50%' }}>
          <TextInput style={{ width: '50%' }} source="trustedContact.firstName" label="First Name" />
        </td>
        <td style={{ width: '50%' }}>
          <TextInput style={{ width: '50%' }} source="trustedContact.lastName" label="Last Name" />
        </td>
      </tr>
      <tr>
        <td>
          <TextInput style={{ width: '50%' }} source="trustedContact.email" type="email" label="E-mail" />
        </td>
        <td>
          <TextInput style={{ width: '50%' }} source="trustedContact.telephone" type="mobile" label="Telephone" parse={phoneParser} format={phoneFormatter} />
        </td>
      </tr>
      <tr>
        <td>
          <SelectInput style={{ width: '50%' }} source="trustedContact.relationship" label="Relationship" choices={trustedContactRelationship} optionText="name" optionValue="id" />
        </td>
      </tr>
    </tbody>
  </table>
);



// WEBPACK FOOTER //
// ./src/components/User/children/TrustedContact.jsx